module.exports = __webpack_public_path__ + "img/d6955c5.png";